import { Redirect } from "react-router-dom";

import { Card2 } from "@/ui2/atoms/Card";
import { Heading2 } from "@/ui2/atoms/Heading";
import { useAdminProfile } from "@/portals/(admin)/(profile)/api/queries/useAdminProfile";
import { useCosignSupervisor } from "@/features/cosignature/hooks/useCosignSupervisor";

import { ADMIN_BASE_REDIRECT_ROUTE } from "../constants";

import { CosignatureSelectionProvider } from "./CosignatureSelectionProvider";
import { CosignatureTabs } from "./CosignatureTabs";

export function Cosignature() {
  const { isLoading, isSupervisor } = useCosignSupervisor();
  const { data: defaultSupervisorId, isSuccess } = useAdminProfile({
    select: (p) => p.username,
  });

  if (isLoading || !isSuccess) return null;

  if (!isSupervisor) {
    return <Redirect to={ADMIN_BASE_REDIRECT_ROUTE} />;
  }

  return (
    <Card2 as="section" className="tw:mx-auto tw:w-full tw:flex-col tw:gap-4">
      <Heading2 as="h1" className="tw:px-6 tw:pt-6" size={3}>
        Co-signature
      </Heading2>

      <CosignatureSelectionProvider>
        <CosignatureTabs defaultSupervisorId={defaultSupervisorId} />
      </CosignatureSelectionProvider>
    </Card2>
  );
}
